import axios from 'axios'
import store from '@/store'

import { API_BASE, apiErrorHandler, ApiFilter, isDefinedAndNotNull, isNotEmpty } from '../api'
import Auth from '../auth'

const PLAID_ENDPOINT = `${API_BASE}plaid/`

export default class PlaidAPI {
  publicTokenCreate() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .get(`${PLAID_ENDPOINT}public-token-create/`, options)
      .then(res => res.data)
      .catch(apiErrorHandler({ apiName: 'PlaidAPI.publicTokenCreate' }))
    return promise
  }

  publicTokenExchange(publicToken) {
    const data = {
      'publicToken': publicToken,
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .post(`${PLAID_ENDPOINT}public-token-exchange/`, data, options)
      .then(res => res.data)
      .catch(apiErrorHandler({ apiName: 'PlaidAPI.publicTokenExchange' }))
    return promise
  }
}